// extracted by mini-css-extract-plugin
module.exports = {"ajoca6s":"ajoca6s","with-image":"with-image","default":"default","colormode-dark":"colormode-dark","i6op735":"i6op735","dwtruy8":"dwtruy8"};